// ============================================
// UPDATED: /frontend/src/api/dashboard.api.js
// ADDED: getListingById and updateListing methods for edit functionality
// ============================================

import apiClient from './client.js';

export const dashboardAPI = {
  // Get dashboard overview
  getOverview: async () => {
    console.log('[dashboardAPI] 📡 GET /dashboard/overview');
    try {
      const response = await apiClient.get('/dashboard/overview');
      console.log('[dashboardAPI] ✅ Overview response:', response.data);
      return response.data;
    } catch (error) {
      console.error('[dashboardAPI] ❌ Overview error:', error);
      throw error;
    }
  },

  // Get user listings
  getListings: async (filters = {}) => {
    const params = new URLSearchParams(filters);
    console.log('[dashboardAPI] 📡 GET /dashboard/listings', filters);
    try {
      const response = await apiClient.get(`/dashboard/listings?${params}`);
      console.log('[dashboardAPI] ✅ Listings response:', response.data);
      return response.data;
    } catch (error) {
      console.error('[dashboardAPI] ❌ Listings error:', error);
      throw error;
    }
  },

  // ⭐ NEW: Get single listing by ID for editing
  getListingById: async (listingId) => {
    console.log('[dashboardAPI] 📡 GET /listings/' + listingId);
    try {
      const response = await apiClient.get(`/listings/${listingId}`);
      console.log('[dashboardAPI] ✅ Listing detail response:', response.data);
      return response.data;
    } catch (error) {
      console.error('[dashboardAPI] ❌ Listing detail error:', error);
      throw error;
    }
  },

  // ⭐ NEW: Update listing
  updateListing: async (listingId, data) => {
    console.log('[dashboardAPI] 📝 PATCH /listings/' + listingId, data);
    try {
      const response = await apiClient.patch(`/listings/${listingId}`, data);
      console.log('[dashboardAPI] ✅ Listing update successful:', response.data);
      return response.data;
    } catch (error) {
      console.error('[dashboardAPI] ❌ Listing update error:', error);
      throw error;
    }
  },

  // Get ad performance
  getPerformance: async () => {
    console.log('[dashboardAPI] 📡 GET /dashboard/performance');
    try {
      const response = await apiClient.get('/dashboard/performance');
      console.log('[dashboardAPI] ✅ Performance response:', response.data);
      return response.data;
    } catch (error) {
      console.error('[dashboardAPI] ❌ Performance error:', error);
      throw error;
    }
  },

  // Delete listing
  deleteListing: async (listingId) => {
    console.log('[dashboardAPI] 🗑️ DELETE /dashboard/listings/' + listingId);
    try {
      const response = await apiClient.delete(`/dashboard/listings/${listingId}`);
      console.log('[dashboardAPI] ✅ Delete successful:', response.data);
      return response.data;
    } catch (error) {
      console.error('[dashboardAPI] ❌ Delete error:', error);
      throw error;
    }
  },

  // Suspend listing
  suspendListing: async (listingId) => {
    console.log('[dashboardAPI] ⏸️ PATCH /dashboard/listings/' + listingId + '/suspend');
    try {
      const response = await apiClient.patch(`/dashboard/listings/${listingId}/suspend`);
      console.log('[dashboardAPI] ✅ Suspend successful:', response.data);
      return response.data;
    } catch (error) {
      console.error('[dashboardAPI] ❌ Suspend error:', error);
      throw error;
    }
  },

  // Reactivate listing
  reactivateListing: async (listingId) => {
    console.log('[dashboardAPI] ▶️ PATCH /dashboard/listings/' + listingId + '/reactivate');
    try {
      const response = await apiClient.patch(`/dashboard/listings/${listingId}/reactivate`);
      console.log('[dashboardAPI] ✅ Reactivate successful:', response.data);
      return response.data;
    } catch (error) {
      console.error('[dashboardAPI] ❌ Reactivate error:', error);
      throw error;
    }
  },

  // Get featured pricing with optional listingId
  getFeaturedPricing: async (listingId = null) => {
    const url = listingId 
      ? `/dashboard/featured/pricing?listingId=${listingId}`
      : '/dashboard/featured/pricing';
    
    console.log('[dashboardAPI] 📡 GET', url);
    try {
      const response = await apiClient.get(url);
      console.log('[dashboardAPI] ✅ Pricing response:', response.data);
      return response.data;
    } catch (error) {
      console.error('[dashboardAPI] ❌ Pricing error:', error);
      throw error;
    }
  },

  // Promote to featured - send correct payload
  promoteToFeatured: async (data) => {
    console.log('[dashboardAPI] ⭐ POST /dashboard/featured/promote', data);
    try {
      const response = await apiClient.post('/dashboard/featured/promote', data);
      console.log('[dashboardAPI] ✅ Promote response:', response.data);
      return response.data;
    } catch (error) {
      console.error('[dashboardAPI] ❌ Promote error:', error);
      throw error;
    }
  },

  // Check promotion status
  checkPromotionStatus: async (promotionId) => {
    console.log('[dashboardAPI] 📡 GET /dashboard/featured/status/' + promotionId);
    try {
      const response = await apiClient.get(`/dashboard/featured/status/${promotionId}`);
      console.log('[dashboardAPI] ✅ Status response:', response.data);
      return response.data;
    } catch (error) {
      console.error('[dashboardAPI] ❌ Status error:', error);
      throw error;
    }
  },

  // Get subscription history
  getSubscriptionHistory: async () => {
    console.log('[dashboardAPI] 📡 GET /dashboard/subscription/history');
    try {
      const response = await apiClient.get('/dashboard/subscription/history');
      console.log('[dashboardAPI] ✅ History response:', response.data);
      return response.data;
    } catch (error) {
      console.error('[dashboardAPI] ❌ History error:', error);
      throw error;
    }
  },

  // Update user profile
  updateProfile: async (data) => {
    console.log('[dashboardAPI] 📝 PATCH /user/profile', data);
    try {
      const response = await apiClient.patch('/user/profile', data);
      console.log('[dashboardAPI] ✅ Profile update successful:', response.data);
      return response.data;
    } catch (error) {
      console.error('[dashboardAPI] ❌ Profile update error:', error);
      throw error;
    }
  },

  // Update settings
  updateSettings: async (data) => {
    console.log('[dashboardAPI] ⚙️ PATCH /user/settings', data);
    try {
      const response = await apiClient.patch('/user/settings', data);
      console.log('[dashboardAPI] ✅ Settings update successful:', response.data);
      return response.data;
    } catch (error) {
      console.error('[dashboardAPI] ❌ Settings update error:', error);
      throw error;
    }
  },

  // Upgrade subscription
  upgradeSubscription: async (data) => {
    console.log('[dashboardAPI] 🚀 POST /subscription/upgrade', data);
    try {
      const response = await apiClient.post('/subscription/upgrade', data);
      console.log('[dashboardAPI] ✅ Upgrade response:', response.data);
      return response.data;
    } catch (error) {
      console.error('[dashboardAPI] ❌ Upgrade error:', error);
      throw error;
    }
  }
};